import { render, staticRenderFns } from "./ShopOrdersList.vue?vue&type=template&id=77a0c8cb&scoped=true"
import script from "./ShopOrdersList.vue?vue&type=script&lang=js"
export * from "./ShopOrdersList.vue?vue&type=script&lang=js"
import style0 from "./ShopOrdersList.vue?vue&type=style&index=0&id=77a0c8cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0c8cb",
  null
  
)

export default component.exports